/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".lightHd[_ngcontent-%COMP%]{color:gray!important}.deleteIcon-alignmet[_ngcontent-%COMP%]{margin:0 0 8px;cursor:pointer;float:right}.rectangle-wrapper[_ngcontent-%COMP%]{-ms-flex-align:baseline;align-items:baseline}.checkbox-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:checked ~ .checkmark-default[_ngcontent-%COMP%]{background-color:#bdbdbd;border-color:#bdbdbd}"];
export { styles as styles };
